module.exports = __webpack_public_path__ + "img/mystic-miners-2.770da519.webp";